import { Grid, Typography, makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
   title: {
      fontWeight: 'bold',
      marginBottom: 10
   },
   content: {
      textAlign: 'justify',
      margin: '10px 0'
   },
   list: {
      margin: '10px 0px',
      padding: 10,
      backgroundColor: '#f9f9f9',
      height: 140,
      gap: 2,
      overflowY: 'scroll',
      flexDirection: 'column'
   }
})

const NotRegisterEmailsModal = ({ emails }) => {
   const classes = useStyles()
   return (
      <Grid container direction="column">
         <Typography variant="body1" className={classes.title}>
            Relación completada con observaciones
         </Typography>
         <Grid container className={classes.content}>
            <Typography variant="body2">
               El proceso se realizó correctamente. Sin embargo, los siguientes usuarios no pudieron relacionarse porque
               no se encuentran registrados:
            </Typography>
            <Grid container className={classes.list}>
               {emails?.map(email => (
                  <Grid item container>{email}</Grid>
               ))}
            </Grid>
            <Typography variant="body2">Por favor, valide la información e intente nuevamente</Typography>
         </Grid>
      </Grid>
   )
}

export default NotRegisterEmailsModal
